/* Fiat: replace the two existing card sources; retain all media nodes/order. */
(function () {
  'use strict';

  var PRODUCT_ID = '10812647473486';
  var SLOTS = {"switch":["74011425669454","74011425866062"],"controls":["56115436650830","74011425702222","74011425898830"]};
  var theme = window.T4SThemeSP;
  var jq = window.jQuery_T4NT;
  if (!theme || !theme.Carousel || !theme.Carousel.prototype ||
      typeof theme.Carousel.prototype.thumbnailsMarkup !== 'function' || typeof jq !== 'function') return;

  function json(text) { try { return JSON.parse(text); } catch (_) { return null; } }
  var root = Array.from(document.querySelectorAll('[data-product-featured]')).find(function (node) {
    var data = json(node.getAttribute('data-product-featured'));
    return data && String(data.id) === PRODUCT_ID && data.isMainProduct === true;
  });
  if (!root || root.__coFiatGalleryCards) return;
  var metadata = json(root.getAttribute('data-product-featured'));
  var configNode = root.querySelector('[data-co-fiat-gallery-cards]');
  var config = configNode && json(configNode.textContent);
  var gallery = root.querySelector('[data-main-media][data-t4s-gallery]');
  var form = metadata.formID && root.querySelector(metadata.formID);
  if (!config || String(config.productId) !== PRODUCT_ID || !config.variants || !gallery || !form) return;

  function selectedVariant() {
    var selector = form.querySelector('[name="id"]');
    return selector ? String(selector.value) : '';
  }
  function asset(value) {
    if (!value || typeof value.src !== 'string' || typeof value.alt !== 'string' ||
        !Number.isInteger(value.width) || value.width < 1 || !Number.isInteger(value.height) || value.height < 1) return null;
    try {
      var url = new URL(value.src, 'https://www.caroptions.nl');
      if (url.protocol !== 'https:' || !['cdn.shopify.com', 'www.caroptions.nl', 'caroptions.nl'].includes(url.hostname) ||
          !url.pathname.includes('/files/') || !url.searchParams.has('v')) return null;
      return { src: url.href, width: value.width, height: value.height, alt: value.alt };
    } catch (_) { return null; }
  }
  var originals = {};
  Object.keys(SLOTS).forEach(function (key) {
    var node = gallery.querySelector('[data-media-id="' + SLOTS[key][0] + '"]');
    var img = node && node.querySelector('img[data-master]');
    if (img) originals[key] = asset({ src: img.getAttribute('data-master'), width: Number(img.getAttribute('width')),
      height: Number(img.getAttribute('height')), alt: img.getAttribute('alt') || '' });
  });
  if (!Object.keys(SLOTS).every(function(key){ return originals[key]; })) return;

  var activeVariant = selectedVariant();
  var latestCarousel = gallery.flickityt4s || null;
  function pair() {
    var entry = config.variants[activeVariant];
    var images = {};
    var complete = Object.keys(SLOTS).every(function(key){ images[key] = entry && asset(entry[key]); return !!images[key]; });
    return complete ? images : originals;
  }
  function widthUrl(src, width) {
    var url = new URL(src);
    url.searchParams.set('width', String(width));
    return url.href;
  }
  function replaceNode(node, image, thumbnail) {
    if (!node) return;
    Array.from(node.querySelectorAll('img')).forEach(function (img) {
      if (img.getAttribute('data-master') === image.src && img.getAttribute('data-co-fiat-card-source') === image.src) return;
      var resolved = widthUrl(image.src, Math.min(image.width, thumbnail ? 360 : 1600));
      img.setAttribute('data-master', image.src);
      img.setAttribute('data-src', resolved);
      // Drop a previously loaded responsive candidate before setting the new source.
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      // These two changing images load directly, outside the original lazy sizing queue.
      img.removeAttribute('data-sizes');
      img.classList.remove('lazyloadt4s', 'lazyloadt4sing', 'lazyautosizes');
      img.classList.add('lazyloadt4sed');
      img.setAttribute('src', resolved);
      img.setAttribute('width', image.width);
      img.setAttribute('height', image.height);
      img.setAttribute('alt', image.alt);
      img.setAttribute('data-co-fiat-card-source', image.src);
    });
    Array.from(node.querySelectorAll('.t4s_ratio')).forEach(function (ratio) {
      ratio.style.setProperty('--aspect-ratioapt', String(image.width / image.height));
      ratio.style.setProperty('--mw-media', image.width + 'px');
      if (thumbnail) ratio.style.backgroundImage = 'url("' + widthUrl(image.src, 360) + '")';
    });
  }
  function replaceSlots(container, images, thumbnail) {
    if (!container) return;
    Object.keys(SLOTS).forEach(function(key){SLOTS[key].forEach(function(id){
      Array.from(container.querySelectorAll('[data-media-id="'+id+'"]')).forEach(function(node){replaceNode(node,images[key],thumbnail);});
    });});
  }
  function orderGallery(){
    var order=config.galleryOrder&&config.galleryOrder[activeVariant];if(!order)return;
    var slides=Array.from(gallery.querySelectorAll('[data-main-slide]'));if(!slides.length)return;
    var parent=slides[0].parentNode;slides.sort(function(a,b){var ai=order.indexOf(a.getAttribute('data-media-id')),bi=order.indexOf(b.getAttribute('data-media-id'));return(ai<0?1000:ai)-(bi<0?1000:bi);}).forEach(function(n){parent.appendChild(n);});
  }
  function patchSources() {
    var images = pair();
    replaceSlots(gallery, images, false);
    // StarApps clones these two offscreen caches on each different hero group.
    replaceSlots(document.querySelector('#multi-variant-info'), images, false);
    replaceSlots(document.querySelector('#multi-variant-thumb'), images, true);
    return images;
  }
  function patchLiveThumbs(images) {
    var nav = latestCarousel && latestCarousel.$carouselNav && latestCarousel.$carouselNav[0];
    if (!nav) nav = root.querySelector('.t4s-carousel__nav');
    if (!nav) return;
    var slides = Array.from(gallery.querySelectorAll('[data-main-slide]'));
    var thumbs = Array.from(nav.querySelectorAll('.t4s-carousel__nav-item'));
    // Native thumbnails have no media ID; their index equals the native slide index.
    if (slides.length !== thumbs.length) return;
    slides.forEach(function (slide, index) {
      Object.keys(SLOTS).forEach(function (key) {
        if (SLOTS[key].includes(slide.getAttribute('data-media-id'))) replaceNode(thumbs[index], images[key], true);
      });
    });
  }

  var nativeThumbnails = theme.Carousel.prototype.thumbnailsMarkup;
  theme.Carousel.prototype.thumbnailsMarkup = function () {
    if (this.el === gallery) {
      latestCarousel = this;
      orderGallery();
      // Kalles calls this before constructing Flickity; StarApps also calls it on rebuild.
      patchSources();
    }
    var result = nativeThumbnails.apply(this, arguments);
    if (this.el === gallery) patchLiveThumbs(pair());
    return result;
  };
  root.__coFiatGalleryCards = true;
  jq(root).on('variant:changed.coFiatGalleryCards', function (event) {
    activeVariant = event.currentVariant ? String(event.currentVariant.id) : selectedVariant();
    patchLiveThumbs(patchSources());
  });
  patchLiveThumbs(patchSources());
}());


/* Native Fiat model content: no navigation or document reload. */
(function(){'use strict';
function init(){var config=document.querySelector('[data-co-fiat-gallery-cards]');if(!config)return;var root=config.closest('[data-product-featured]'),select=root.querySelector('select[name="id"]');if(!select||root.__coFiatNativeModels)return;root.__coFiatNativeModels=true;
var spider='55031269228878',valid=[spider,'60976635904334','60976635937102'],active=String(select.value);
function bindLocation(){var isSpider=active===spider;root.querySelectorAll('.co-fiat-box-location,.co-fiat-spider-location').forEach(function(node){node.classList.toggle('location_selector',node.classList.contains(isSpider?'co-fiat-spider-location':'co-fiat-box-location'));});var chosen=root.querySelector('.location_selector select');if(chosen&&isSpider)chosen.disabled=false;}
function present(){var kind=active===spider?'spider':'box';config.setAttribute('data-co-fiat-current',kind);document.querySelectorAll('[data-co-fiat-mode]').forEach(function(n){n.hidden=n.getAttribute('data-co-fiat-mode')!==kind;});document.querySelectorAll('[data-co-fiat-variant]').forEach(function(n){n.hidden=n.getAttribute('data-co-fiat-variant')!==active;});var title=kind==='spider'?'CarPlay & Android Auto voor Fiat / Abarth':'CarPlayBox voor Fiat';root.querySelectorAll('.t4s-product__title').forEach(function(n){if(n.textContent!==title)n.textContent=title;});document.querySelectorAll('.t4s-sticky-atc__title').forEach(function(n){if(n.textContent!==title)n.textContent=title;});document.querySelectorAll('[data-co-fiat-faq-title]').forEach(function(n){var original=n.getAttribute('data-co-fiat-faq-title'),q=kind==='spider'?original.replace('de CarPlayBox','CarPlay & Android Auto'):original;if(n.textContent!==q)n.textContent=q;});bindLocation();}
function resetOptions(){root.querySelectorAll('.gpo-element input[type="checkbox"]').forEach(function(n){if(n.checked){n.checked=false;n.dispatchEvent(new Event('change',{bubbles:true}));}});root.querySelectorAll('.co-fiat-box-location select,.co-fiat-spider-location select').forEach(function(n){var value=n.closest('.co-fiat-spider-location')?'CarOptions - Bleiswijk':'';if(n.value!==value){n.value=value;n.dispatchEvent(new Event('change',{bubbles:true}));}});bindLocation();}
function update(v){var id=String(v&&v.id||select.value);if(!valid.includes(id))return;var changed=id!==active;active=id;present();if(changed)resetOptions();}
root.addEventListener('change',function(e){if(e.target===select)update();});if(window.jQuery_T4NT)window.jQuery_T4NT(root).on('variant:changed.coFiatNative',function(e){update(e.currentVariant);});new MutationObserver(present).observe(root,{childList:true,subtree:true});update();
}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();}());
